import { render, staticRenderFns } from "./CollectionSorting.vue?vue&type=template&id=04c01bbe&scoped=true&lang=pug&"
import script from "./CollectionSorting.vue?vue&type=script&lang=js&"
export * from "./CollectionSorting.vue?vue&type=script&lang=js&"
import style0 from "./CollectionSorting.vue?vue&type=style&index=0&id=04c01bbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c01bbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04c01bbe')) {
      api.createRecord('04c01bbe', component.options)
    } else {
      api.reload('04c01bbe', component.options)
    }
    module.hot.accept("./CollectionSorting.vue?vue&type=template&id=04c01bbe&scoped=true&lang=pug&", function () {
      api.rerender('04c01bbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/collection/CollectionSorting.vue"
export default component.exports